import { render, staticRenderFns } from "./desempenios.vue?vue&type=template&id=231fc014&scoped=true&"
import script from "./desempenios.vue?vue&type=script&lang=js&"
export * from "./desempenios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231fc014",
  null
  
)

export default component.exports